import { TouristLimitModal } from './TouristLimitModal';

export default TouristLimitModal;
